export default __webpack_public_path__ + "static/windscribe-edge-extension-b365ac2af640f85a7165c4aabd2d6b7b.png";